// Try multiple ways to ensure the script runs
function initKiksMegaMenu() {
    // console.log('Kiks mega menu JS loaded');

    // Find all kiks collection menus on the page
    const menus = document.querySelectorAll('.kiks-collections-nav');
    // console.log('Found menus:', menus.length);

    if (menus.length === 0) {
        // console.log('No menus found, retrying in 100ms');
        setTimeout(initKiksMegaMenu, 100);
        return;
    }

    menus.forEach(function (menuContainer) {
        const collectionItems = menuContainer.querySelectorAll('.kiks-collection-item');
        const megaNav = menuContainer.closest('.mega-nav');
        const categoryContent = megaNav ? megaNav.querySelector('.kiks-category-content') : null;
        const categorySections = categoryContent ? categoryContent.querySelectorAll('.kiks-category-section') : [];

        // console.log('Collection items:', collectionItems.length);
        // console.log('Category sections:', categorySections.length);
        // console.log('Category content:', categoryContent);

        // Function to switch category
        function switchCategory(category) {
            // console.log('Switching to category:', category);

            // Remove active class from all collection items
            collectionItems.forEach(function (ci) {
                ci.classList.remove('active');
            });

            // Remove active class from all category sections
            categorySections.forEach(function (cs) {
                cs.classList.remove('active');
            });

            // Add active class to current collection item
            const currentItem = menuContainer.querySelector('[data-category="' + category + '"]');
            // console.log('Current item found:', currentItem);
            if (currentItem) {
                currentItem.classList.add('active');
            }

            // Show corresponding category section
            const targetSection = categoryContent ? categoryContent.querySelector('.kiks-category-section[data-category="' + category + '"]') : null;
            // console.log('Target section found:', targetSection);
            if (targetSection) {
                targetSection.classList.add('active');
            } else {
                // console.log('No target section found for category:', category);
            }
        }

        // Use event delegation for better reliability
        menuContainer.addEventListener('mouseenter', function (e) {
            const item = e.target.closest('.kiks-collection-item');
            if (item) {
                // console.log('Mouse enter on:', item);
                const category = item.dataset.category;
                // console.log('Category from mouseenter:', category);
                if (category) {
                    switchCategory(category);
                }
            }
        }, true);

        menuContainer.addEventListener('click', function (e) {
            const item = e.target.closest('.kiks-collection-item');
            if (item) {
                console.log('Click on:', item);
                
                // Check if the click was on a link inside the collection item
                const link = e.target.closest('a');
                if (link) {
                    // If it's a link, let it work normally (don't prevent default)
                    console.log('Link clicked, allowing navigation');
                    return;
                }
                
                // Only prevent default for non-link clicks
                e.preventDefault();
                const category = item.dataset.category;
                // console.log('Category from click:', category);
                if (category) {
                    switchCategory(category);
                }
            }
        });

        // Initialize first category as active
        if (collectionItems.length > 0 && categorySections.length > 0) {
            const firstCategory = collectionItems[0].dataset.category;
            if (firstCategory) {
                switchCategory(firstCategory);
            }
        }
    });
}

// Try multiple ways to ensure the script runs
document.addEventListener('DOMContentLoaded', initKiksMegaMenu);
document.addEventListener('load', initKiksMegaMenu);
// Also try immediately in case DOM is already loaded
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKiksMegaMenu);
} else {
    initKiksMegaMenu();
}